export var getCellStylesFromCtx = function (options) {
    var _a;
    var columnDef = options.ctx.column.columnDef;
    var styles = {
        width: options.ctx.column.getSize(),
    };
    // all column widths stretch proportionally to fill the available space
    if (options.stretchItems === 'all') {
        styles.flex = options.ctx.column.getSize();
    }
    // Column widths set in px will have a fixed width, while columns set to flex will expand to fill the available space
    if (options.stretchItems === 'flex' && ((_a = columnDef.meta) === null || _a === void 0 ? void 0 : _a.isFlex)) {
        styles.flex = "".concat(columnDef.size, " 0 auto");
    }
    if (columnDef.minSize) {
        styles.minWidth = columnDef.minSize;
    }
    if (columnDef.maxSize) {
        styles.maxWidth = columnDef.maxSize;
    }
    return styles;
};
